// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// require("@rails/ujs").start()
// import "@rails/ujs"; // Rails UJSをインポートするだけで自動的に初期化されます

import "@hotwired/turbo-rails";
// import "controllers"
// Turbo Driveを無効化
Turbo.session.drive = false;

import Rails from "@rails/ujs"
Rails.start()

require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
// require("jquery")

//= require rails-ujs
//= require activestorage
//= require turbolinks
//= require jquery #追記
//= require jquery_ujs #追記
//= require_tree .

//= require jquery3
//= require popper
//= require bootstrap-sprockets

//= require serviceworker-companion

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

// import '../maps_autocomplete';

// import $ from 'jquery';
// global.$ = jQuery;
